import { Trans } from "@lingui/macro";
import { useMediaQuery, useTheme } from "@mui/material";
import { IApiEpBillingProductPlanProduct } from "@smp/api";
import { UiBox, UiButton, UiTypography } from "@smp/ui";
import { textCapitalize } from "@smp/utils";
import clsx from "clsx";

import { useHumanizer } from "@/hooks/use_humanizer";

import { useStyles } from "./period.css";

export const Period = ({
  isActive,
  onClick,
  product,
  ...props
}: {
  isActive: boolean;
  onClick: (product: IApiEpBillingProductPlanProduct) => void;
  product: IApiEpBillingProductPlanProduct;
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { humanizePeriodUnit } = useHumanizer();

  const classes = useStyles();

  const handleClick = () => {
    onClick(product);
  };

  return (
    <UiButton
      {...props}
      color={isActive ? "primary" : "paper"}
      className={clsx(
        classes.button_period,
        isMobile && classes["button_period--mobile"],
      )}
      onClick={handleClick}
      variant={isActive ? "contained" : "outlined"}
    >
      {textCapitalize(
        humanizePeriodUnit(
          product.period_units,
          product.period_length,
          product.period_length <= 1,
        ),
      )}
      {product.period_length === 1 && product.period_units === 8 && (
        <UiBox className={classes.button_period__badge}>
          <UiTypography className={classes.button_period__badge__text} noWrap>
            <Trans>__dialog_purchase.prepare.periods.period__Save {33}%</Trans>
          </UiTypography>
        </UiBox>
      )}
    </UiButton>
  );
};
